const GET_AGREE_FLG = "getAgreeFlg";
const SET_AGREE_FLG = "setAgreeFlg";
const INIT_AGREE_NEWS = "initAgreeNews";
const FORCE_SET_AGREE_FLG = "forceSetAgreeFlg";
const SET_RE_AGREEMENT_FLG = "setReAgreementFlg";
const SET_FORCE_NEWS_FLG = "setForceNewsFlg";
const SET_AGREE_MENT_FLG = "setAgreementFlag";
export {

    GET_AGREE_FLG,
    SET_AGREE_FLG,
    INIT_AGREE_NEWS,
    FORCE_SET_AGREE_FLG,
    SET_RE_AGREEMENT_FLG,
    SET_FORCE_NEWS_FLG,
    SET_AGREE_MENT_FLG
};
